import { ButtonListItem, List, NavLink, Stack } from "@fideus-ui/core";
import {
  Assignment,
  Business,
  Description,
  Logout as LogoutIcon,
} from "@fideus-ui/core/icons";
import { useNavigate, useParams } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../_app/featureFlags";
import { useTranslation } from "../_app/i18n";
import { translations } from "./translations";

export function TaxAdvisorMenu() {
  const t = useTranslation(translations);
  const navigate = useNavigate();
  const isDisclosureEnabled = useIsFeatureEnabled(
    "disclosureReviewInTaxAdvisorPortal"
  );
  const params = useParams({ strict: false });
  const taxAdvisoryId =
    params != null &&
    "taxAdvisoryId" in params &&
    typeof params.taxAdvisoryId === "string"
      ? params.taxAdvisoryId
      : undefined;

  return (
    <Stack direction="column">
      <List sx={{ flexGrow: 1 }}>
        {taxAdvisoryId && (
          <NavLink
            to="/beratung/$taxAdvisoryId/unternehmen"
            params={{ taxAdvisoryId }}
            icon={<Business />}
            label={t("companies")}
          />
        )}
        {taxAdvisoryId && (
          <NavLink
            to="/beratung/$taxAdvisoryId/reviews"
            params={{ taxAdvisoryId }}
            icon={<Assignment />}
            label={t("openReviews")}
          />
        )}
        {taxAdvisoryId && isDisclosureEnabled && (
          <NavLink
            to="/beratung/$taxAdvisoryId/offenlegung"
            params={{ taxAdvisoryId }}
            icon={<Description />}
            label={t("offenlegung")}
          />
        )}
        <ButtonListItem
          onClick={() => navigate({ to: "/abmelden" })}
          icon={<LogoutIcon />}
          label={t("logout")}
        />
      </List>
    </Stack>
  );
}
